export default __webpack_public_path__ + "static/orange-f82758d326084a4ba84ba80fcc8ceb3e.png";